import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import Scores from './Scores';
import './FinancialWellness.css';

const FinancialWellness = ({ toggleBlueprintLoaded }) => (
  <div className="financial-wellness">
    <h2>Financial Wellness</h2>
    <div className="content">
      <Scores toggleBlueprintLoaded={toggleBlueprintLoaded} />
    </div>
  </div>
);

FinancialWellness.propTypes = {
  toggleBlueprintLoaded: PropTypes.func,
};

FinancialWellness.defaultProps = {
  toggleBlueprintLoaded: noop,
};
export default FinancialWellness;
